import img1 from "../../../assets/logos/papers.svg";
import img2 from "../../../assets/logos/patents.svg";
import img3 from "../../../assets/logos/fellowships.svg";
import img4 from "../../../assets/logos/prod.svg";
import img6 from "../../../assets/logos/skilldev.svg";
import img7 from "../../../assets/logos/research-and-development.svg";
import img8 from "../../../assets/logos/startup.svg";
import img9 from "../../../assets/logos/collaborat.svg";

export const achievementRow1 = [
  {
    id: 1,
    image: img1,
    alt: "Publications-logo",
    count: 210,
    title: "Publications",
  },
  {
    id: 2,
    image: img2,
    alt: "Patents-logo",
    count: 27,
    title: "Patents",
  },
  {
    id: 3,
    image: img3,
    alt: "Fellowships-logo",
    count: 377,
    title: "Fellowships",
  },
  {
    id: 4,
    image: img4,
    alt: "Tech-Products-logo",
    count: 46,
    title: "Tech Products",
  },
];

export const achievementRow2 = [
  {
    id: 5,
    image: img6,
    alt: "Skill-Dev-logo",
    count: 6728,
    title: "Skill Development",
  },
  {
    id: 6,
    image: img7,
    alt: "R&D-logo",
    count: 90,
    title: "R&D Projects",
  },
  {
    id: 7,
    image: img8,
    alt: "Startups-logo",
    count: 42,
    title: "Startups",
  },
  {
    id: 8,
    image: img9,
    alt: "Revenew-logo",
    count: 6,
    title: "Collaborators",
  },
];